import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { API_CONFIG } from '../../../utils/apiConfig';
import { shouldRecordPunchingTime } from '../../../utils/punchingTimeUtils';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const logoutUser = async () => {
      try {
        const token = localStorage.getItem('token');
        const email = localStorage.getItem('email');
        const role = localStorage.getItem('role');
        
        if (token && email && shouldRecordPunchingTime(role)) {
          await recordPunchOut(email, token);
        }
        
        await logout();
      } catch (error) {
        console.error('Error during logout:', error);
      } finally {
        localStorage.clear();
        navigate('/login');
      }
    };
    logoutUser();
  }, [logout, navigate]);

  const recordPunchOut = async (email, token) => {
    try {
      const punchOutData = {
        email: email,
        punchOut: new Date().toISOString(),
        logoutMethod: 'web'
      };

      try {
        const response = await fetch(`${API_CONFIG.BASE_URL}/api/punching-times/record-logout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(punchOutData)
        });

        if (response.ok) {
          console.log('🔇 Punch-out recorded via API (silently)');
        } else if (response.status === 404 || response.status === 400) {
          console.log('🔇 Punch-out API not available (404/400), using local storage');
          throw new Error('API punch-out not available');
        } else {
          throw new Error('API punch-out failed');
        }
      } catch (apiError) {
        // Silently store in localStorage as fallback
        console.log('🔇 Storing punch-out locally');
        const today = new Date().toISOString().split('T')[0];
        const existingTimes = JSON.parse(localStorage.getItem('punchingTimes') || '[]');
        
        const userRecords = existingTimes.filter(record => 
          record.email === email && 
          record.date === today && 
          !record.punchOut
        );
        
        if (userRecords.length > 0) {
          const latestRecord = userRecords[userRecords.length - 1];
          const updatedTimes = existingTimes.map(record => 
            record.id === latestRecord.id 
              ? { ...record, punchOut: punchOutData.punchOut }
              : record
          );
          localStorage.setItem('punchingTimes', JSON.stringify(updatedTimes));
        } else {
          const punchOutRecord = {
            id: `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            email: email,
            name: 'Unknown User',
            role: 'staff',
            date: today,
            punchIn: null,
            punchOut: punchOutData.punchOut,
            createdAt: new Date().toISOString(),
            isLocal: true
          };
          
          const updatedTimes = [...existingTimes, punchOutRecord];
          localStorage.setItem('punchingTimes', JSON.stringify(updatedTimes));
        }
      }
    } catch (error) {
      // Completely silent - no console error
      console.log('🔇 Punch-out feature unavailable, continuing with logout');
    }
  };

  return <div>Logging out...</div>;
};

export default Logout;